import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import buy from "./buy";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    buy,
  });
